import ReactGA from 'react-ga4';

// only send analytics in production
const isProduction = process.env.NODE_ENV === 'production';
const sendAnalytics = (fn: Function, ...args: any[]) => {
  if (isProduction) {
    fn(...args);
  }
};

export const initGA = () => {
  if (isProduction) {
    ReactGA.initialize('G-DE2RD1FY3S');
  } else {
    console.log('Analytics not initialized in non-production environment');
  }
};

export const logPageView = (page_path?: string) => {
  sendAnalytics(ReactGA.send, { hitType: "pageview", page: page_path });
};

export const logEvent = (
  eventName: string,
  params: Record<string, string | number>
) => {
  sendAnalytics(ReactGA.event, eventName, params);
};

export const logException = (description: string, fatal = false) => {
  sendAnalytics(ReactGA.event, 'exception', { description, fatal });
}; 